import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { FaRegCalendarAlt } from "react-icons/fa";
import { FaLocationDot, FaRegClock } from "react-icons/fa6";
import {IoIosArrowBack} from "react-icons/io";
import axios from "axios";
import { IoIosArrowDown } from "react-icons/io";



function StranKoncerta() {
    const { id } = useParams();

    //  HOOKI NA VRHU
    const [koncert, setKoncert] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [openProgramModal, setOpenProgramModal] = useState(false);
    const [ime, setIme] = useState("");
    const [email, setEmail] = useState("");
    const [steviloVstopnic, setSteviloVstopnic] = useState("");

    useEffect(() => {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/koncerti/${id}`)
            .then((res) => {
                if (!res.ok) {
                    throw new Error("Koncert ni najden");
                }
                return res.json();
            })
            .then((data) => {
                setKoncert(data);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Napaka pri pridobivanju koncerta:", err);
                setError(err.message);
                setLoading(false);
            });
    }, [id]);

    const formatirajDatum = (datum) => {
        const meseci = ["januar", "februar", "marec", "april", "maj", "junij", "julij", "avgust", "september", "oktober", "november", "december"];
        const date = new Date(datum);
        const ure = date.getHours().toString().padStart(2, "0");
        const minute = date.getMinutes().toString().padStart(2, "0");
        return `${date.getDate()}. ${meseci[date.getMonth()]} ob ${ure}:${minute}`;
    };

    const toRoman = (num) => {
        const romanMap = [
            ["M", 1000], ["CM", 900], ["D", 500], ["CD", 400],
            ["C", 100], ["XC", 90], ["L", 50], ["XL", 40],
            ["X", 10], ["IX", 9], ["V", 5], ["IV", 4], ["I", 1]
        ];

        return romanMap.reduce((acc, [letter, value]) => {
            while (num >= value) {
                acc += letter;
                num -= value;
            }
            return acc;
        }, "");
    };

    const [privacyChecked, setPrivacyChecked] = useState(false);
    const [vir, setVir] = useState("");
    const [drugiVir, setDrugiVir] = useState("");


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!privacyChecked) {
            alert("Prosimo, da se strinjate s pravilnikom o zasebnosti.");
            return;
        }
        const poslaniVir = vir === "drugo" ? drugiVir : vir;



        const novaRezervacija = {
            ime,
            email,
            steviloVstopnic,
            koncertId: koncert._id,
            koncertIme: koncert.ime,
            koncertDatum: koncert.datum,
            koncertLokacija: koncert.lokacija,
            vir: poslaniVir,
        };

        try {
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/rezervacije`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(novaRezervacija),
            });

            if (res.ok) {
                alert("Rezervacija uspešna!");
                setIme("");
                setEmail("");
                setSteviloVstopnic("");
            } else {
                alert("Napaka pri pošiljanju rezervacije.");
            }
        } catch (err) {
            console.error("Napaka pri pošiljanju rezervacije:", err);
            alert("Napaka pri povezavi s strežnikom.");
        }
    };

    //  POGOJI ZA NALAGANJE/ERROR
    if (loading) return <h2 style={{ marginTop: "8em" }}>Nalaganje...</h2>;
    if (error) return <h2>{error}</h2>;

    // slike
    const images = koncert.slike.map((slika) => ({
        original: slika,
        thumbnail: slika,
    }));

    const izvajalciData = typeof koncert.izvajalci === "string"
        ? JSON.parse(koncert.izvajalci)
        : koncert.izvajalci;





    const VsebinaKoncert = ({ vsebina }) => {
        const [razsirjeno, setRazsirjeno] = useState(false);
        const [imaVec, setImaVec] = useState(false);

        const ref = React.useRef(null);

        useEffect(() => {
            if (ref.current) {
                setImaVec(ref.current.scrollHeight > 250);
            }
        }, [vsebina]);


        return (
            <>
                <div
                    ref={ref}
                    style={{
                        overflow: "hidden",
                        maxHeight: razsirjeno
                            ? `${ref.current?.scrollHeight}px`
                            : "240px",
                        transition: "max-height .45s ease"
                    }}
                >
                    <div
                        style={{
                            lineHeight: "1.6"
                        }}
                        dangerouslySetInnerHTML={{
                            __html: vsebina
                        }}
                    />
                </div>


                {imaVec && (
                    <button
                        style={{
                            background: "none",
                            border: "none",
                            color: "#4C7F93",
                            cursor: "pointer",
                            padding: "1em 1em 1em 0",
                            fontSize: "1em"
                        }}
                        onClick={() => setRazsirjeno(!razsirjeno)}
                        className="gumb-beri-vec"
                    >
                        {razsirjeno ? "Prikaži manj" : "Preberi več.."}
                    </button>
                )}
            </>
        );
    };



    return (
        <div>
            <section className="koncert-stran center">
                <div className="koncert-levo">
                    <Link to="/koncerti" className="gumb-nazaj-aan center">
                        <IoIosArrowBack /> Nazaj na koncerte
                    </Link>
                    <div className="flex">
                        <h1>{koncert.ime}</h1>
                        {koncert.rezervacijeOmogocene && (
                        <button
                            className="rezerviraj-gumb"
                            onClick={() => {
                                document.getElementById("rezervacija")?.scrollIntoView({
                                    behavior: "smooth",
                                });
                            }}
                        >
                            Rezerviraj  <IoIosArrowDown style={{ marginLeft: "5px"}}  />
                        </button>
                        )}
                    </div>
                    {/*<p style={{ color: "grey" }}>{koncert.podnaslov}</p>*/}
                    <p><FaRegCalendarAlt style={{ marginRight: "10px" }}/>{formatirajDatum(koncert.datum)}</p>
                    <ImageGallery
                        items={images}
                        showPlayButton={false}
                        autoPlay={true}
                        slideInterval={4000}
                        showFullscreenButton={false}
                    />
                </div>

                <div className="koncert-desno">
                    <div className="koncert-stran-vsebina">
                        <h1>O koncertu</h1>

                        {koncert.vsebina && (
                            <VsebinaKoncert
                                vsebina={koncert.vsebina}
                            />
                        )}


                    </div>
                </div>
            </section>




            <section className="koncert-program-sekcija">
                <div className="center koncert-program">
                    <div className="izvajalci-pri-programu">
                        <div className="izvajalci-pri-programu-tekst">
                            <h1>Izvajalci:</h1>
                            <hr />
                            {izvajalciData.map((skupina, index) => (
                                <div key={index} className="izvajalci-karta">
                                    {skupina.imeSkupine && <h3>{skupina.imeSkupine}</h3>}
                                    {skupina.izvajalci.map((izvajalec, idx) => (
                                        <p key={idx}>
                                            <b>{izvajalec.ime}</b> - {izvajalec.instrument}
                                        </p>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="center aca-mobile">
                        <div className="stran-koncerta-program-wrapper">
                            <div className="center-program">
                                <h1>Program:</h1>
                                <hr style={{ width: "10%" }} />
                            </div>

                            <div className="array-program">
                                {koncert.program.map((item, index) => (
                                    <div key={index}>
                                        <h3>{item.skladatelj}: {item.naslov}</h3>
                                        {Array.isArray(item.stavki) && item.stavki.length > 0 ? (
                                            item.stavki
                                                .map((s, i) =>
                                                    typeof s === "string"
                                                        ? { vrstniRed: i + 1, naslov: s }
                                                        : s
                                                )
                                                .map((stavek, idx) => (
                                                    <p key={idx}>
                                                        <b>{toRoman(stavek.vrstniRed)}.</b> {stavek.naslov}
                                                    </p>
                                                ))
                                        ) : (
                                            <p></p>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                {koncert.programskiList && (
                    <div className="programski-list-gumb-wrapper">
                        <button
                            className="koncert-gumb"
                            onClick={() => setOpenProgramModal(true)}
                        >
                            Pregled koncertnega lista
                        </button>
                    </div>
                )}
            </section>


            {koncert.rezervacijeOmogocene && (
                <section className="rezervacija-vstopnic center" id="rezervacija">
                    <div className="rezervacija-vstopnic-levo">
                        <h1>Rezervacija brezplačnih vstopnic</h1>
                        <form className="rezervacija-vstopnic-form" onSubmit={handleSubmit}>
                            <input
                                type="text"
                                placeholder="Ime in priimek"
                                value={ime}
                                onChange={(e) => setIme(e.target.value)}
                                required
                            />
                            <input
                                type="email"
                                placeholder="E-mail"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                            <input
                                type="number"
                                placeholder="Št. vstopnic"
                                className="input-st-kart"
                                value={steviloVstopnic}
                                onChange={(e) => setSteviloVstopnic(e.target.value)}
                                required
                            />
                            <label className="vir-mb" htmlFor="vir">Kje ste izvedeli za koncert?</label>
                            <select className="vir-select" id="vir" name="vir" value={vir} onChange={e => setVir(e.target.value)}>
                                <option value="">-- izberi --</option>
                                <option value="družabna omrežja">Na družabnih omrežjih</option>
                                <option value="plakati">S plakatov</option>
                                <option value="časopisi">Iz časopisov</option>
                                <option value="radio">Po radiu</option>
                                <option value="drugo">Drugo</option>
                            </select>

                            {vir === "drugo" && (
                                <input
                                    type="text"
                                    placeholder="Drugo"
                                    value={drugiVir}
                                    onChange={e => setDrugiVir(e.target.value)}
                                />
                            )}

                            <div className="checkbox-wrapper" style={{ margin: "1em 0", fontSize: "0.95em" }}>
                                <input
                                    type="checkbox"
                                    id="privacy"
                                    checked={privacyChecked}
                                    onChange={(e) => setPrivacyChecked(e.target.checked)}
                                    required
                                />
                                <label htmlFor="privacy" style={{ marginLeft: "0.5em" }}>
                                    Strinjam se s <a href="/pravilnik-zasebnosti" target="_blank" style={{ color: "#4C7F93" }}>pogoji zasebnosti</a>.
                                </label>
                            </div>
                            <button type="submit" className="koncert-gumb koncert-gumb-na-beli">Rezerviraj</button>
                        </form>
                    </div>





                    <div className="rezervacija-vstopnic-desno">

                        <h1>Podrobnosti koncerta</h1>

                        <div className="koncert-info-grid">
                            <div className="info-card">
                                <FaRegCalendarAlt className="info-icon" />
                                <span className="info-title">Kdaj</span>
                                <span className="info-value">{formatirajDatum(koncert.datum)}</span>
                            </div>

                            <div className="info-card">
                                <FaLocationDot className="info-icon" />
                                <span className="info-title">Kje</span>
                                <span className="info-value">{koncert.lokacija}</span>
                            </div>

                            {koncert.trajanje && koncert.trajanje !== "0:00" && (
                                <div className="info-card">
                                    <FaRegClock className="info-icon" />
                                    <span className="info-title">Trajanje</span>
                                    <span className="info-value">{koncert.trajanje} h</span>
                                </div>
                            )}
                        </div>

                    </div>
                </section>
            )}




            {openProgramModal && (
                <div
                    className="modal-overlay"
                    onClick={() => setOpenProgramModal(false)}
                >

                    <div
                        className="modal-page programski-list-modal"
                        onClick={(e) => e.stopPropagation()}
                    >

                        <button
                            className="modal-close"
                            onClick={() => setOpenProgramModal(false)}
                        >
                            ✕
                        </button>


                        <div className="programski-list">

                            <h1 className="programski-list-naslov">
                                Koncertni list
                            </h1>

                            <div
                                className="programski-list-vsebina"
                                dangerouslySetInnerHTML={{
                                    __html: koncert.programskiList,
                                }}
                            />

                        </div>

                    </div>

                </div>
            )}
        </div>
    );
}

export default StranKoncerta;
